// extracted by mini-css-extract-plugin
export default {"wrapper":"main-page_wrapper__PcyD3"};